import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';

import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerSharedPageInformationComponent } from './components/pages/information/information.component';
import { OrganizerSharedPageListComponent } from './components/pages/list/list.component';
import { OrganizerSharedPageOverviewComponent } from './components/pages/overview/overview.component';
import { OrganizerSharedPageStepsComponent } from './components/pages/steps/steps.component';
import { OrganizerSharedActionListComponent } from './components/shared/action-list/action-list.component';
import { OrganizerSharedActivityTimeslotListComponent } from './components/shared/activity-timeslot-list/activity-timeslot-list.component';
import { OrganizerSharedCalendarComponent } from './components/shared/calendar/calendar.component';
import { OrganizerSharedDisplayPlansComponent } from './components/shared/display-plans/display-plans.component';
import { OrganizerSharedEditLiveUrlSectionComponent } from './components/shared/edit-live-url-section/edit-live-url-section.component';
import { OrganizerSharedEditSectionComponent } from './components/shared/edit-section/edit-section.component';
import { OrganizerSharedEditTimeslotDateComponent } from './components/shared/edit-timeslot-date/edit-timeslot-date.component';
import { OrganizerSharedFooterComponent } from './components/shared/footer/footer.component';
import { OrganizerSharedFormWrapperComponent } from './components/shared/form-wrapper/form-wrapper.component';
import { OrganizerSharedHeaderComponent } from './components/shared/header/header.component';
import { OrganizerSharedLayoutDashboardComponent } from './components/shared/layouts/dashboard/dashboard.component';
import { OrganizerSharedLayoutDashboardHeaderComponent } from './components/shared/layouts/dashboard/header/header.component';
import { OrganizerSharedLayoutDashboardHeaderNavigationComponent } from './components/shared/layouts/dashboard/header/navigation/navigation.component';
import { OrganizerSharedLayoutEditFieldComponent } from './components/shared/layouts/edit-field/edit-field.component';
import { OrganizerSharedLayoutFunnelComponent } from './components/shared/layouts/funnel/funnel.component';
import { OrganizerSharedLayoutListComponent } from './components/shared/layouts/list/list.component';
import { OrganizerSharedNavigationButtonsComponent } from './components/shared/navigation-buttons/navigation-buttons.component';
import { OrganizerSharedPageContainerComponent } from './components/shared/page-container/page-container.component';
import { OrganizerSharedFormPlansComponent } from './components/shared/plans/plans.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentModule,
    CoreModule,
    RouterModule,
    LocalizeRouterModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    ParamethorModule,
    NgxPaginationModule,
  ],
  declarations: [
    OrganizerSharedCalendarComponent,
    OrganizerSharedEditTimeslotDateComponent,
    OrganizerSharedEditLiveUrlSectionComponent,
    OrganizerSharedFormWrapperComponent,
    OrganizerSharedLayoutDashboardComponent,
    OrganizerSharedLayoutDashboardHeaderComponent,
    OrganizerSharedLayoutDashboardHeaderNavigationComponent,
    OrganizerSharedLayoutFunnelComponent,
    OrganizerSharedLayoutListComponent,
    OrganizerSharedNavigationButtonsComponent,
    OrganizerSharedPageContainerComponent,
    OrganizerSharedPageInformationComponent,
    OrganizerSharedPageOverviewComponent,
    OrganizerSharedPageStepsComponent,
    OrganizerSharedPageListComponent,
    OrganizerSharedLayoutEditFieldComponent,
    OrganizerSharedHeaderComponent,
    OrganizerSharedActionListComponent,
    OrganizerSharedFormPlansComponent,
    OrganizerSharedDisplayPlansComponent,
    OrganizerSharedEditSectionComponent,
    OrganizerSharedFooterComponent,
    OrganizerSharedActivityTimeslotListComponent,
  ],
  providers: [DatePipe],
  exports: [
    OrganizerSharedFormWrapperComponent,
    OrganizerSharedLayoutFunnelComponent,
    OrganizerSharedLayoutListComponent,
    OrganizerSharedNavigationButtonsComponent,
    OrganizerSharedPageContainerComponent,
    OrganizerSharedPageInformationComponent,
    OrganizerSharedPageOverviewComponent,
    OrganizerSharedPageStepsComponent,
    OrganizerSharedEditTimeslotDateComponent,
    OrganizerSharedEditLiveUrlSectionComponent,
    OrganizerSharedCalendarComponent,
    OrganizerSharedLayoutDashboardComponent,
    OrganizerSharedPageListComponent,
    OrganizerSharedLayoutEditFieldComponent,
    OrganizerSharedHeaderComponent,
    OrganizerSharedActionListComponent,
    OrganizerSharedFooterComponent,
    OrganizerSharedFormPlansComponent,
    OrganizerSharedDisplayPlansComponent,
    OrganizerSharedEditSectionComponent,
    OrganizerSharedActivityTimeslotListComponent,
  ],
})
export class OrganizerSharedModule {}
